import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import ApplePayIcon from '@/assets/icons/payments/applePay.png';

export const ApplePayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.APPLE_PAY}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.APPLE_PAY)}
    >
      <img className="h-4 w-10" src={ApplePayIcon} alt="apple-pay" />
    </Box>
  );
};
